import React from 'react';
import formatPledgeAmount from '../../../shared/utils/formatPledgeAmount';

const fmt = (cents) => formatPledgeAmount(cents);

export default function PledgeRollupBar({ rollup }) {
  if (!rollup) return null;
  const receivedPct = rollup.total_pledged_cents > 0
    ? Math.round((rollup.total_received_cents / rollup.total_pledged_cents) * 100)
    : 0;

  return (
    <div className="pt-rollup">
      <div className="pt-rollup__tile">
        <div className="pt-rollup__label">Total Pledged</div>
        <div className="pt-rollup__value">{fmt(rollup.total_pledged_cents)}</div>
        <div className="pt-rollup__sub">Across {rollup.pledges_count} pledges</div>
      </div>
      <div className="pt-rollup__tile">
        <div className="pt-rollup__label">Total Received</div>
        <div className="pt-rollup__value">{fmt(rollup.total_received_cents)}</div>
        <div className="pt-rollup__sub">{receivedPct}% of pledged</div>
      </div>
      <div className="pt-rollup__tile">
        <div className="pt-rollup__label">Outstanding</div>
        <div className="pt-rollup__value">{fmt(rollup.outstanding_cents)}</div>
        {rollup.overdue_cents > 0 && (
          <div className="pt-rollup__sub pt-rollup__sub--error">{fmt(rollup.overdue_cents)} overdue</div>
        )}
        {rollup.failed_installments_count > 0 && (
          <div className="pt-rollup__sub pt-rollup__sub--error">
            {rollup.failed_installments_count} {rollup.failed_installments_count === 1 ? 'payment' : 'payments'} failed
          </div>
        )}
      </div>
      <div className="pt-rollup__tile">
        <div className="pt-rollup__label">Written Off</div>
        <div className="pt-rollup__value">{fmt(rollup.written_off_cents)}</div>
      </div>
    </div>
  );
}
